module.exports = __webpack_public_path__ + "d3c0522b4e36abfbd47587e044bfa4aa.pdf";